import * as THREE from 'three'

export interface SceneKit {
  readonly scene: THREE.Scene
  readonly sun: THREE.DirectionalLight
  readonly stars: THREE.Points
}

/** Campo di stelle deterministico: stesso cielo a ogni avvio. */
function makeStars(count: number, radius: number): THREE.Points {
  const pos = new Float32Array(count * 3)
  const col = new Float32Array(count * 3)
  let seme = 987654321
  const rnd = (): number => {
    // generatore lineare congruenziale: basta e non porta dipendenze
    seme = (seme * 1664525 + 1013904223) >>> 0
    return seme / 4294967296
  }

  for (let i = 0; i < count; i++) {
    // distribuzione uniforme sulla sfera, non uniforme in latitudine
    const u = rnd() * 2 - 1
    const th = rnd() * Math.PI * 2
    const s = Math.sqrt(1 - u * u)
    pos[i * 3] = radius * s * Math.cos(th)
    pos[i * 3 + 1] = radius * s * Math.sin(th)
    pos[i * 3 + 2] = radius * u

    const caldo = rnd()
    const lum = 0.45 + rnd() * 0.55
    col[i * 3] = lum * (0.82 + caldo * 0.18)
    col[i * 3 + 1] = lum * 0.9
    col[i * 3 + 2] = lum * (1 - caldo * 0.12)
  }

  const geom = new THREE.BufferGeometry()
  geom.setAttribute('position', new THREE.BufferAttribute(pos, 3))
  geom.setAttribute('color', new THREE.BufferAttribute(col, 3))
  return new THREE.Points(geom, new THREE.PointsMaterial({
    size: radius * 0.0016,
    vertexColors: true,
    sizeAttenuation: true,
    depthWrite: false,
    transparent: true,
    opacity: 1,
  }))
}

export function createScene(): SceneKit {
  const scene = new THREE.Scene()

  const sun = new THREE.DirectionalLight(0xfff4e0, 3.1)
  sun.position.set(1, 0.25, 0.45).normalize().multiplyScalar(1e7)
  scene.add(sun)

  // nello spazio l'ombra e nera: l'ambiente serve solo a non perdere le forme
  scene.add(new THREE.AmbientLight(0x2a3a52, 0.5))

  const stars = makeStars(3200, 2e7)
  scene.add(stars)

  return { scene, sun, stars }
}
